import { useEffect, useState } from 'react';

import { CBBanner } from './chrome-browser-banner';

import { menuPageDialogOpened } from 'features/menu-page';
import { mozartDialogOpened } from 'features/mozart-notifications';

export function StartupNotifications() {
  const [dialogOpened, setDialogOpened] = useState({
    isOpenMozart: false,
    isOpenMenuPage: false,
  });

  const mozartDialog = mozartDialogOpened();
  const menuPageDialog = menuPageDialogOpened();

  const isDisplayedBanners =
    !dialogOpened.isOpenMenuPage && !dialogOpened.isOpenMozart;

  useEffect(() => {
    mozartDialog.add(({ detail }) =>
      setDialogOpened(s => ({ ...s, isOpenMozart: detail })),
    );
    menuPageDialog.add(({ detail }) =>
      setDialogOpened(s => ({ ...s, isOpenMenuPage: detail })),
    );
    return () => {
      mozartDialog.remove();
      menuPageDialog.remove();
    };
  }, []);

  return (
    <>
      <div
        aria-label='startup-notifications-banners'
        style={{ display: isDisplayedBanners ? 'block' : 'none' }}
      >
        <CBBanner />
        {/* Add other banners to startup here */}
      </div>

      {/* Add your other startup dialogs or modals here */}
    </>
  );
}
